export default __webpack_public_path__ + "static/media/finance2.fcfd0650.svg";